import { DataVizContainerCommonUtils } from '../../../common/types';
import {
  extractMetaFromSection,
  getKpiUiSectionInputsFromKpiSectionValue,
} from '../../../common/utils';
import {
  KpiFactboxSingleMetricVizData,
  KpiFactboxSingleMetricVizExternalProps,
} from '../../types';
import { KpiSingleColumnUiComponentProps } from './types';

type SingleColumnFactboxSection =
  KpiSingleColumnUiComponentProps['componentProps']['options']['section'];

export const singleColumnFactboxDataToUiComponentProps = (
  data: KpiFactboxSingleMetricVizData,
  externalProps: KpiFactboxSingleMetricVizExternalProps,
  { t, dataFieldValueFormatter }: DataVizContainerCommonUtils
): KpiSingleColumnUiComponentProps => {
  const { dataResponse } = data;
  const { sectionValue } = dataResponse;
  const { mainValue, subValues } = getKpiUiSectionInputsFromKpiSectionValue(
    sectionValue,
    externalProps.preferences,
    t,
    dataFieldValueFormatter
  );
  const singleMetricSection: SingleColumnFactboxSection = {
    mainValue,
    subValues,
  };
  const meta = extractMetaFromSection(sectionValue);
  return {
    meta,
    componentProps: {
      options: {
        title: data.title,
        subtitle: data.subtitle,
        footer: data.footer,
        section: singleMetricSection,
        fontSize: data.fontSize,
      },
    },
  };
};
